"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IStorageStrategy = /** @class */ (function () {
    function IStorageStrategy() {
    }
    return IStorageStrategy;
}());
exports.IStorageStrategy = IStorageStrategy;
//# sourceMappingURL=IStorageStrategy.js.map